import React from "react";
import './FooterThree.css'
export default function FooterThree() {
  return (
    <div className="footerThree">
      <div className="subHead">Office Locations</div>
      <div className="f3rContainer">
        <div className="f3r">
          <div className="f3rCity">NewDelhi</div>
          <div className="f3rText">
            A-258, Bhishma Pitamah Marg, Block A, Defence Colony, New Delhi,
            Delhi 110024
          </div>
        </div>
        <div className="f3r">
          <div className="f3rCity">NewDelhi</div>
          <div className="f3rText">
            A-258, Bhishma Pitamah Marg, Block A, Defence Colony, New Delhi,
            Delhi 110024
          </div>
        </div>
        <div className="f3r">
          <div className="f3rCity">NewDelhi</div>
          <div className="f3rText">
            A-258, Bhishma Pitamah Marg, Block A, Defence Colony, New Delhi,
            Delhi 110024
          </div>
        </div>
        <div className="f3r">
          <div className="f3rCity">NewDelhi</div>
          <div className="f3rText">
            A-258, Bhishma Pitamah Marg, Block A, Defence Colony, New Delhi,
            Delhi 110024
          </div>
        </div>
        <div className="f3r">
          <div className="f3rCity">NewDelhi</div>
          <div className="f3rText">
            A-258, Bhishma Pitamah Marg, Block A, Defence Colony, New Delhi,
            Delhi 110024
          </div>
        </div>
        <div className="f3r">
          <div className="f3rCity">NewDelhi</div>
          <div className="f3rText">
            A-258, Bhishma Pitamah Marg, Block A, Defence Colony, New Delhi,
            Delhi 110024
          </div>
        </div>
      </div>
    </div>
  );
}
